import { PaletteOptions } from "@mui/material";
import merge from "lodash/merge";

export const parsePalette = (
  localPalette?: PaletteOptions,
  remotePalette?: Partial<PaletteOptions>,
): PaletteOptions | undefined => {
  if (!localPalette && !remotePalette) return undefined;
  return merge(localPalette || {}, remotePalette || {}) as PaletteOptions;
};
